module.exports = __webpack_public_path__ + "img/measurement_info_left_neck_front.839171a0.jpg";